import { textStyle } from '@/components/ui/Typography/Body/Text/style';
import { tv } from '@/utils/libs/tailwind-variants';
/**
 * TextInput のスタイル
 */
export const textInputStyle = tv({
    base: [
        textStyle({ color: 'base', size: 'md' }),
        'placeholder:text-inactive',
        'w-full h-[44px]',
        'py-10 px-16',
        'border border-solid border-gray-300',
        'bg-gray-75 focus:bg-gray-50',
        'rounded-md',
        // 非活性
        'disabled:text-textGray',
        'disabled:opacity-100',
        'disabled:bg-gray-75',
        // 読み取り専用
        'read-only:!text-base',
        'read-only:bg-gray-50',
        'read-only:!pointer-events-auto read-only:cursor-not-allowed',
        // エラー
        'aria-[invalid="true"]:bg-red-50',
        'aria-[invalid="true"]:border-red-100 focus:aria-[invalid="true"]:border-red-100',
    ],
});
